import(/* webpackMode: "eager", webpackExports: ["ThemeColorSync"] */ "/vercel/path0/genesis/product/apps/demo/src/components/ThemeColorSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookiesProvider"] */ "/vercel/path0/genesis/product/apps/demo/src/providers/cookies.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KeyboardSafeHeightProvider"] */ "/vercel/path0/genesis/product/apps/demo/src/providers/keyboard-safe-height.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MediaFactoryProvider"] */ "/vercel/path0/genesis/product/apps/demo/src/providers/media-factory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RunPreferencesProvider"] */ "/vercel/path0/genesis/product/apps/demo/src/providers/run-preferences.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/genesis/product/apps/demo/src/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PageViewTracker"] */ "/vercel/path0/genesis/product/packages/analytics/src/react/PageViewTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/genesis/product/packages/ui/src/components/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/styles/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../public/demo/assets/fonts/PPMondwest-Regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../../public/demo/assets/fonts/PPMondwest-Regular.woff\",\"weight\":\"400\",\"style\":\"normal\"}],\"variable\":\"--font-ppmondwest\"}],\"variableName\":\"ppmondwest\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/vercel/path0/node_modules/nuqs/dist/adapters/next/app.js");
